import { useState } from "react";

export function useCategorySelection() {
  const [selectedCategories, setSelectedCategories] = useState([]);

  const handleSelectAll = (checked, filteredCategories) => {
    if (checked) {
      setSelectedCategories(filteredCategories.map((c) => c.id));
    } else {
      setSelectedCategories([]);
    }
  };

  const handleSelectCategory = (id, checked) => {
    if (checked) {
      setSelectedCategories([...selectedCategories, id]);
    } else {
      setSelectedCategories(selectedCategories.filter((cId) => cId !== id));
    }
  };

  return {
    selectedCategories,
    setSelectedCategories,
    handleSelectAll,
    handleSelectCategory,
  };
}
